/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useContext, useState } from "react";
import { Box, Typography, Paper, Card, Grid } from "@mui/material";
import InputAdornment from "@mui/material/InputAdornment";
import IconButton from "@mui/material/IconButton";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { Helmet } from "react-helmet";
import Styles from "./styles";
import Logo from "../../assets/images/BSG-logo.png";
import ForgotScreenBG from "../../assets/images/LoginBackground.png";
import InputField from "../../components/Layout/fieldInput/InputField";
import ShowPassword from "../../components/Svg/ShowPassword";
import HidePassword from "../../components/Svg/HidePassword";
import Button from "../../components/Layout/Button/NewButton";
import { AlertStatus } from "../../contants";
import NewOTPInput from "../../components/OTPInput/NewOtpInput";
import { ToastAlertContext } from "../../Config/Providers/ToastAlert";

const CommonStyles = {
  buttonStyle: {
    marginTop: "40px",
  },
};

// const createArrayByLen = (len) => new Array(len ?? 1).fill(0);
// const OTP_LEN = 6;

const endPoint = process.env.REACT_APP_API_BASE_URL;

export function PasswordStrengthBar({ password }) {
  const calculateStrength = () => {
    const { length } = password;
    let strength = 0;

    // Check length and numbers
    if (length >= 8 && /[0-9]/.test(password)) {
      strength += 1;
    }
    // Check for uppercase and lowercase characters
    if (/[a-z]/.test(password) && /[A-Z]/.test(password)) {
      strength += 1;
    }

    // Check for special characters
    if (/[!@#$%^&*(),.?":{}|<>]/.test(password)) {
      strength += 1;
    }
    return strength;
  };

  const strength = calculateStrength();

  return (
    <div>
      {password ? (
        <Grid container style={{ marginBottom: "1.5rem", gap: 9 }}>
          {strength >= 0 && (
            <Grid
              item
              xs={4}
              style={{
                maxWidth: "96px",
                height: "5px",
                borderRadius: "15px",
                backgroundColor: "#E87466",
              }}
            />
          )}
          {strength >= 1 && (
            <Grid
              item
              xs={4}
              style={{
                maxWidth: "96px",
                height: "5px",
                borderRadius: "15px",
                backgroundColor: "#FFDB9B",
              }}
            />
          )}
          {strength > 2 && (
            <Grid
              item
              xs={4}
              s
              style={{
                maxWidth: "96px",
                borderRadius: "15px",
                height: "5px",
                backgroundColor: "#9AE68B",
              }}
            />
          )}
        </Grid>
      ) : null}
    </div>
  );
}

function ChangePassword() {
  const TITLE = "Change Password - BSG ContributionAdmin";
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [Otp, setOtp] = useState("");
  // eslint-disable-next-line no-unused-vars
  const { memberId, authToken } = useParams();
  const toast = useContext(ToastAlertContext);
  const navigate = useNavigate();

  // Toggle password for New Password Field
  const [showNewPassword, setShowNewPassword] = useState(false);
  const handleClickShowNewPassword = () => setShowNewPassword(!showNewPassword);
  const handleMouseDownNewPassword = () => setShowNewPassword(!showNewPassword);

  // Toggle password for Confirm New Password Field
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const handleMouseDownConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword(!showConfirmPassword);
  const handleOTPChange = (otpValue) => {
    setOtp(otpValue);
  };
  const handleCopy = (e) => {
    e.preventDefault();
  };

  const handlePaste = (e) => {
    e.preventDefault();
  };

  // eslint-disable-next-line consistent-return
  const postData = async () => {
    try {
      if (!Otp) {
        toast.show("Please enter OTP", AlertStatus.ERROR);
        return;
      }
      const data = {
        newPassword,
        memberId,
        otp: Number(Otp),
      };

      const response = await axios.post(
        `${endPoint}/updatePasswordByOtp`,
        data,
        {
          headers: { "X-Auth-Token": authToken },
        },
      );

      if (response.data.code === 200) {
        toast.show(response.data.message, AlertStatus.SUCCESS);
        setTimeout(() => {
          navigate("/");
        }, 3000);
      } else {
        toast.show(response.message, AlertStatus.ERROR);
      }
    } catch (err) {
      toast.show(err.message, AlertStatus.ERROR);
      if (err.response) {
        // The request was made, but the server responded with an error
        toast.show(err.response.data.message, AlertStatus.ERROR);
      }
    }
  };

  // validation of Change Password screen
  const check = (e) => {
    if (newPassword === "") {
      toast.show("New Password can not be Empty", AlertStatus.ERROR);
    } else if (newPassword.length < 8) {
      toast.show("Please enter at least 8 characters", AlertStatus.ERROR);
    } else if (confirmPassword === "") {
      toast.show("Please confirm your Password", AlertStatus.ERROR);
    } else if (confirmPassword !== newPassword) {
      toast.show("Confirm password does not match", AlertStatus.ERROR);
    } else {
      postData(e);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    check(e);
  };

  return (
    <>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Box
        style={{
          backgroundImage: `url(${ForgotScreenBG})`,
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          height: "100vh",
        }}
      >
        <Box
          style={{
            height: 100,
            display: "flex",
            justifyContent: "center",
            padding: 20,
          }}
        >
          <img src={Logo} alt="logo" />
        </Box>
        <Box
          style={{
            padding: "15px 45px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "calc(100vh - 200px)",
          }}
        >
          {/* right side of which have instructions */}
          <Card style={Styles.cardStyle}>
            <div style={Styles.cardContainer}>
              <Box style={{ marginBottom: 10 }}>
                <Typography style={Styles.cardHeadingTypography}>
                  Tips for creating a strong password.
                </Typography>
              </Box>

              <Typography style={Styles.cardMessageTypography}>
                Creating a strong and secure password is an important part of
                protecting your BSG Account.
              </Typography>
              <Typography style={Styles.cardMessageTypography}>
                Here are some tips for creating a strong password :
              </Typography>
            </div>

            <Box
              style={{ marginTop: 25, marginLeft: "3rem", color: "#FFFFFF" }}
            >
              <ListItem sx={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <ListItemIcon>
                  <CheckCircleIcon sx={{ color: "#FFFFFF" }} />
                </ListItemIcon>
                <ListItemText
                  sx={{
                    maxWidth: "305px",
                  }}
                  primary="Use at least 8 characters "
                />
              </ListItem>

              <ListItem sx={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <ListItemIcon>
                  <CheckCircleIcon sx={{ color: "#FFFFFF" }} />
                </ListItemIcon>
                <ListItemText
                  sx={{ maxWidth: "305px" }}
                  primary="Use a mix of letters (uppercase and lowercase), numbers and symbols "
                />
              </ListItem>

              <ListItem sx={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <ListItemIcon>
                  <CheckCircleIcon sx={{ color: "#FFFFFF" }} />
                </ListItemIcon>
                <ListItemText
                  sx={{ maxWidth: "305px" }}
                  primary="Don't use your name, username or account name "
                />
              </ListItem>

              <ListItem sx={{ paddingTop: "0px", paddingBottom: "0px" }}>
                <ListItemIcon>
                  <CheckCircleIcon sx={{ color: "#FFFFFF" }} />
                </ListItemIcon>
                <ListItemText
                  sx={{ maxWidth: "305px" }}
                  primary='Avoid predictable passwords such as "BSG123#"'
                />
              </ListItem>
            </Box>
          </Card>

          {/* Password Screen fields (left side) */}
          <Paper elevation={1} style={Styles.changePasswordPaper}>
            <form onSubmit={handleSubmit}>
              <div style={Styles.divContainer}>
                <Typography style={Styles.typographyHeading}>
                  Change Password
                </Typography>
                <Typography style={Styles.typographyMessage}>
                  Enter the OTP we just sent to your registered email.
                </Typography>
                <div
                  style={{
                    width: "250px",
                    display: "flex",
                    justifyContent: "space-between",
                    marginBottom: "1rem",
                  }}
                >
                  <NewOTPInput
                    onOTPChange={handleOTPChange}
                    style={{
                      height: 40,
                      background: "#F2F2F2",
                      fontSize: 16,
                      color: "#00000",
                    }}
                  />
                </div>
                <div>
                  <InputField
                    required
                    label="New Password"
                    name="newPassword"
                    // variant="standard"
                    Placeholder="New Password"
                    type={showNewPassword ? "text" : "password"}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    onCopy={handleCopy}
                    onPaste={handlePaste}
                    style={Styles.inputStyle}
                    InputProps={{
                      disableUnderline: true,
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={handleClickShowNewPassword}
                            onMouseDown={handleMouseDownNewPassword}
                          >
                            {showNewPassword ? (
                              <ShowPassword />
                            ) : (
                              <HidePassword />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                  <div style={newPassword ? { marginTop: "-1.8rem" } : {}}>
                    <PasswordStrengthBar password={newPassword} />
                  </div>
                </div>

                <InputField
                  required
                  label="Confirm New Password"
                  name="confirmPassword"
                  Placeholder="Confirm New Password"
                  type={showConfirmPassword ? "text" : "password"}
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  onCopy={handleCopy}
                  onPaste={handlePaste}
                  style={{ ...Styles.inputStyle, marginBottom: "0px" }}
                  InputProps={{
                    disableUnderline: true,
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={handleClickShowConfirmPassword}
                          onMouseDown={handleMouseDownConfirmPassword}
                        >
                          {showConfirmPassword ? (
                            <ShowPassword />
                          ) : (
                            <HidePassword />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
                <Button
                  variant="contained"
                  style={{ ...Styles.buttonStyle, ...CommonStyles.buttonStyle }}
                  type="submit"
                  label="Change Password"
                />
              </div>
            </form>
          </Paper>
        </Box>
      </Box>
    </>
  );
}

export default ChangePassword;
